import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';

@Component({
  selector: 'app-slide1',
  templateUrl: './slide1.page.html',
  styleUrls: ['./slide1.page.scss'],
})
export class Slide1Page implements OnInit {

  constructor(private nav: NavController) { }

  ngOnInit() {
  }

  skip() {
    this.nav.navigateForward("slide-2")
  }

  skipAll() {
    this.nav.navigateRoot("home")
  }

}
